module.exports = __webpack_public_path__ + "media/theme_night.ed94ab0c.mp3";